import React from 'react';
import './home.scss';
import CTitle from  '../title/ctitle.js';
import CCatTitle from '../cattitle/ccattitle.js';
import Basement from '../basement/basement.jsx';
import '../customscroll/customscroll.scss';
import { renderRoutes } from 'react-router-config';
import FoneVideo from '../fonevideo/fonevideo.jsx';
class Home extends React.Component {
  constructor(props) {
    super(props);
  };

  getTitle = () => {
    const { routes } = this.props;
    const routeLink = routes.location && routes.location.pathname;
    const routesElm =  routeLink.split('/');

    if (routesElm[2] === 'category') {
      return <CCatTitle />;
    }
    return <CTitle />;
    ;
  };

  render() {
    return (
      <div className='home-wrap'>
        <FoneVideo />
        {this.getTitle()}
        {renderRoutes(this.props.route.routes)}
        <Basement/>
      </div>
    );
  }
};

export default Home;



// WEBPACK FOOTER //
// ./src/client/components/home/home.jsx